import {NgModule} from '@angular/core';
import {HomeComponent} from '~/app/web/home/home.component';
import {ConfirmComponent} from '~/app/web/confirm/confirm.component';
import {StoreListComponent} from '~/app/web/store-list/store-list.component';
import {ProfileComponent} from '~/app/web/profile/profile.component';
import {CanDeactivateGuard} from '~/app/shared/navigation/can-deactivate.guard';
import {OrderingComponent} from '~/app/web/ordering/ordering.component';
import {InventoryComponent} from '~/app/shared/inventory/inventory.component';
import {MogComponent} from '~/app/web/mog/mog.component';
import {AuthGuardService as AuthGuard} from './shared/navigation/auth-guard.service';
import {RoleGuardService as RoleGuard} from './shared/navigation/role-guard.service';
import {paths} from '~/app/app-paths';
import {NotFoundComponent} from '~/app/shared/not-found/not-found.component';
import {PathResolveService} from '~/app/core/common/services/path-resolve.service';
import {NoAccessComponent} from '~/app/shared/not-found/no-access.component';
import {Error500Component} from '~/app/shared/not-found/error-500.component';
import {NoStoresComponent} from '~/app/shared/not-found/no-stores.component';
import {ChallengeComponent, ChallengeGuard} from 'mclane-webauth-lib';
import {SettingsComponent} from 'mclane-apptemplate-lib';
import {NewItemComponent} from '~/app/web/reports/new-item/new-item.component';
import {StoreListResolver} from '~/app/core/resolvers/StoreListResolver';
import {ItemsResolver} from '~/app/core/resolvers/ItemsResolver';
import {DirectAccessGuard} from "~/app/shared/navigation/direct-access.guard";
import { OrderguideWorksheetComponent } from './web/reports/orderguide-worksheet/orderguide-worksheet.component';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    {
        path: paths.home,
        component: HomeComponent,
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
        resolve: {resolved: StoreListResolver},
        data: {
            breadcrumb: 'Home',
            expectedRole: 'Store'
        },
    },
    {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
    },
    {
        path: paths.storeList,
        component: StoreListComponent,
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
        resolve: {resolved: StoreListResolver},
        data: {
            breadcrumb: 'Store List',
            expectedRole: 'Store'
        },
    },
    {
        path: paths.mog,
        component: MogComponent,
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
        resolve: {resolved: StoreListResolver},
        data: {
            breadcrumb: 'Master Order Guide',
            expectedRole: 'Above_Store'
        },
    },
    {
        path: paths.ordering,
        component: OrderingComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard, DirectAccessGuard],
        resolve: {resolved: StoreListResolver},
        data: {
            expectedRole: 'Store'
        },
    },
    {
        path: paths.profile,
        component: ProfileComponent,
        canDeactivate: [CanDeactivateGuard],
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
        resolve: {
            stores: StoreListResolver,
            items: ItemsResolver

        },
        data: {
            expectedRole: 'Store'
        },
    },
    {
        path: paths.app_inventory,
        component: InventoryComponent,
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard, DirectAccessGuard],
        resolve: {resolved: StoreListResolver},
        data: {
            expectedRole: 'Store'
        },
    },
    
    {
        path: paths.orderconfirm,
        component: ConfirmComponent,
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard, DirectAccessGuard],
        resolve: {resolved: StoreListResolver},
        data: {
            expectedRole: 'Store'
        }
    },
    {
        path: paths.newItemReport,
        component: NewItemComponent,
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
        resolve: {resolved: StoreListResolver},
        data: {
            expectedRole: 'Store'
        }
    },
    {
        path: paths.orderguideworksheet,
        component: OrderguideWorksheetComponent,
        canActivate: [AuthGuard, RoleGuard, ChallengeGuard],
        resolve: {stores: StoreListResolver},
        data: {
            expectedRole: 'Store'
        }
    },
    {
        path: paths.settings,
        component: SettingsComponent,
    },
    {
        path: 'challenge',
        component: ChallengeComponent,
        canActivate: [AuthGuard],
    },
    {
        path: paths.access_denied,
        component: NoAccessComponent
    },
    {
        path: paths.error500,
        component: Error500Component
    },
    {
        path: paths.no_stores,
        component: NoStoresComponent
    },
    {
        path: '**',
        resolve: {
            path: PathResolveService
        },
        component: NotFoundComponent
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
